<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content" @routeAnimation>
	<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
		@if(isLoading || isError || !order) {
		@if (!isError) { <copo-loading-spinner></copo-loading-spinner> }
		} @else {
		@if (isOrderReady){
		<copo-panel-header (backButtonClick)="goBack()" [titleHeaderText]="'eorder.draft.order-card.title' | translate">
			<button type="button" mat-raised-button color="primary" copoFocusMe [disabled]="!hasUserSubmitterRole"
				(click)="evtEditEordrDraft(order.id)">
				<span translate>eorder.draft.order-card.edit</span>
			</button>
		</copo-panel-header>
		<div class="copo-container">
			<div class="grid-column-one-full">
				<div class="copo-section">
					<div class="copo-section-header">
						<span translate>eorder.wizard.summary.header.order.title</span>
					</div>
				</div>
				<div class="copo-section copo-eorder-step-summary">
					<div class="copo-section-body copo-grid">
						<div class="copo-grid-row">
							@if (order.purchaseOrderNumber) {
							<div class="copo-grid-row-column-2">
								<div class="card-content-info">
									<div class="card-content-label" translate>
										eorder.wizard.header.customer-order-number
									</div>
									<div class="card-content-value overflow-ellipse">
										{{ order.purchaseOrderNumber }}
									</div>
								</div>
							</div>
							}
							@if(order.invoicingCurrencyTr !== '' && this.currencyList && this.currencyList.length > 0){
							<div class="copo-grid-row-column-2">
								<div class="card-content-info">
									<div class="card-content-label" translate>
										eorder.wizard.summary.header.currency.po
									</div>
									<div class="card-content-value overflow-ellipse">
										{{ order.invoicingCurrencyTr !== '' ? order.invoicingCurrencyTr : UNDERSCORE }}
									</div>
								</div>
							</div>
							}
							<div class="copo-grid-row-column-2">
								<div class="card-content-info">
									<div class="card-content-label" translate>
										eorder.wizard.order.soldto.name
									</div>
									<div class="card-content-value overflow-ellipse">
										{{ getCustomerDetail(order.soldToRef) || UNDERSCORE }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="copo-container">
			<div class="grid-column-one-full">

				<div class="card-title-block-non-sticky">
					<div class="card-header-left">

						@if (orderItemList.length > 0) {
						<div class="card-title-label">
							<span translate>eorder.draft.order-card.placed.text</span>

							@if(orderItemList.length > 1) {
							{{ orderItemList.length }}
							<span translate>eorder.wizard.product.modification.title.items</span>
							} @else {
							{{ orderItemList.length }}
							<span translate>eorder.wizard.product.modification.title.item</span>
							}
						</div>
						} @else {
						<div class="copo-section copo-error-label">
							<span translate>eorder.draft.order-card.no-item.text</span>
						</div>
						}

					</div>

					@if(orderItemList.length > 0) {
					<div class="card-header-right">
						<div class="quantity-block-container">
							<span class="total-quantity">
								{{ totalQuantity && totalQuantity > 0 ? totalQuantity : UNDERSCORE }}
							</span>
						</div>
						<div class="sub-description-total" translate>eorder.wizard.summary.total.quantity</div>
					</div>
					}
				</div>

			</div>
		</div>
		<div class="grid-column-one-full card-block bottom-margin">
			@for(orderItem of order.listOfRequestOrderItem; track $index; let i = $index) {
			@let productData = orderItem.listOfRequestProductData;
			<div class="card-product-block">
				<div class="card-header copo-dark-theme"
					[ngClass]="getExpandPanelStatus(i) ? 'card-header-top-rounded' : 'card-header-rounded'">
					<div class="card-header-label">
						<div class="header-label" translate>eorder.wizard.product.itemnumber</div>
						<div class="field-value"><span>{{ orderItem.itemNumber }}</span></div>
					</div>
					<div class="card-header-label">
						<div class="header-label" translate>eorder.product.steelgrade</div>
						<div class="field-value">
							<span>
								{{
								productData?.[0]?.characterDescription === ''
								? UNDERSCORE
								:productData?.[0]?.characterDescription
								}}
							</span>
						</div>
					</div>
					<div class="card-header-label">
						<div class="header-label" translate>need4steel.wizard.stepper.product.thickness</div>
						<div class="field-value">
							<span>
								{{ productData?.[1]?.characValueNum || UNDERSCORE }}
							</span>
						</div>
					</div>
					<div class="card-header-label">
						<div class="header-label" translate>need4steel.wizard.stepper.product.width</div>
						<div class="field-value">
							<span>
								{{ productData?.[2]?.characValueNum || UNDERSCORE }}
							</span>
						</div>
					</div>
					<div class="card-header-label">
						<div class="header-label" translate>eorder.wizard.product.quantity</div>
						<div class="field-value">
							<span>
								{{ orderItem.quantityAmount || UNDERSCORE }}
							</span>
						</div>
					</div>
					<div class="card-header-label">
						<div class="header-label" [class.rdd-error]="orderItem.deliveryDateTypeTr === ''" translate>
							eorder.wizard.product.rdd.type
						</div>
						@if (orderItem.deliveryDateTypeTr === 'W') {
						<div class="field-value"><span>{{ this.rddTypeWeek || UNDERSCORE }}</span></div>
						} @else if (orderItem.deliveryDateTypeTr === 'D') {
						<div class="field-value"><span>{{ this.rddTypeDay || UNDERSCORE }}</span></div>
						} @else {
						<div class="field-value rdd-error">
							<span [matTooltip]="'filter.field.invalid' | translate">{{ UNDERSCORE }}</span>
						</div>
						}
					</div>
					<div class="card-action-block">
						<div class="card-header-label">
							@let rddValidation = isRddInPast(orderItem.deliveryDateDisplay);
							<div class="header-label" translate
							[class.rdd-error]="rddValidation || orderItem.deliveryDateTypeTr === ''">
								eorder.wizard.product.rdd
							</div>
							@if (orderItem.deliveryDateTypeTr === 'W') {
							<div class="field-value">
								<span [class.rdd-error]="rddValidation" [matTooltip]="rddValidation
									? ('eorder.wizard.product.rdd.error' | translate)
									: ''">
									{{
									orderItem.deliveryDateDisplay || orderItem.deliveryDateDisplay === ''
									? orderItem.deliveryDateDisplay
									: UNDERSCORE
									}}
								</span>
							</div>
							} @else if (orderItem.deliveryDateTypeTr === 'D') {
							<div class="field-value">
								<span [class.rdd-error]="rddValidation" [matTooltip]="rddValidation
									? ('eorder.wizard.product.rdd.error' | translate)
									: ''">
									{{ orderItem.deliveryDateDisplay || orderItem.deliveryDateDisplay === ''
									? orderItem.deliveryDateDisplay
									: UNDERSCORE
									}}
								</span>
							</div>
							} @else {
							<div class="field-value rdd-error">
								<span [matTooltip]="'filter.field.invalid' | translate">{{ UNDERSCORE }}</span>
							</div>
							}
						</div>
						<button class="card-header-right" type="button" mat-icon-button (click)="expandPanel(i)">
							<mat-icon [ngClass]="getExpandPanelStatus(i) ? 'drop-down-rotate' : ''"
								svgIcon="copo_dropdown"></mat-icon>
						</button>
					</div>
				</div>
				<mat-expansion-panel [expanded]="isExpanded[i]">
					<ng-template matExpansionPanelContent>
						<div class="card-content-row-2">
							<div class="expansion-panel-content">
								<div class="label" translate>transport.mode</div>
								<div class="content">
									{{ getTransportDescription(orderItem.transportModeTr) || UNDERSCORE }}
								</div>
							</div>
							<div class="expansion-panel-content">
								<div class="label" translate>
									eoffer.wizard.delivery.address
								</div>
								<div class="content" [matTooltip]="getShiptoDesc(orderItem.shipToRef ?? '')">
									{{ getShiptoDesc(orderItem.shipToRef ?? '') || UNDERSCORE }}
								</div>
							</div>
							@if (orderItem.xcarb && this.xcarbList && this.xcarbList.length > 0) {
							<div class="expansion-panel-content">
								<div class="label" translate>xcarb.label</div>
								<div class="content">
									{{ getXcarb(orderItem.xcarb) || UNDERSCORE }}
								</div>
							</div>
							}
							@if (orderItem.listOfRequestServiceLevel
							&& orderItem.listOfRequestServiceLevel.length > 0) {
							@let service = orderItem.listOfRequestServiceLevel[0];
							<div class="expansion-panel-content">
								<div class="label" translate>eorder.wizard.product.service.level</div>
								<div class="content">
									{{ getServiceLevel(service.serviceLevelRef) || UNDERSCORE }}
								</div>
							</div>
							}
							@if (orderItem.businessType && this.busList && this.busList.length > 0) {
							<div class="expansion-panel-content">
								<div class="label" translate>eorder.wizard.product.service.level</div>
								<div class="content">
									{{ orderItem.businessType ? orderItem.businessType : UNDERSCORE }}
								</div>
							</div>
							}
						</div>
						@if (productData?.[0]?.characterDescription && isTemplateValid(orderItem.itemNumber)) {
						<div class="card-content-variables">
							@for (prod of productData; track prod.id) {
								@if (!FILTERED_ROW.has(prod.characName)) {
								<div class="expansion-panel-content">
									<div class="label">{{ prod.characName }}</div>
									<div class="content"
											[matTooltip]="prod.characterDescription
											|| prod.characValueNum?.toString()"
										>
											{{
											prod.characterDescription !== ''
											? prod.characterDescription
											: prod.characValueNum !== null && prod.characValueNum !== undefined
											? prod.characValueNum
											: UNDERSCORE
											}}
										</div>
									</div>
								}
							}
						</div>
						} @else {
						<div class="item-error-message">
							<span translate [class.card-error]="true">
								eorder.wizard.product.card.error
							</span>
						</div>
						}
					</ng-template>
				</mat-expansion-panel>
			</div>
			}
		</div>
		}}
	</div>
</div>